var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgECommerce2Line64(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "e-commerce_2-line-64") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 20.5v-1h-1.5v-19h-27v19h-1.5v1h14.5v5.3l-4.85 4.85 0.7 0.7 4.65-4.65 4.65 4.65 0.7-0.7-4.85-4.85v-5.3h14.5zM3.5 11.5h4.7l2.65-2.65 3.050 6.1 3.15-4.2 2 2 5.35-6.4-0.75-0.65-4.65 5.6-2-2-2.85 3.8-2.95-5.9-3.4 3.3h-4.3v-9h25v18h-25v-8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgECommerce2Line64);
export default __webpack_public_path__ + "static/media/e-commerce_2-line-64.735f7e9c8ed11b077ea81620d6566a1c.svg";
export { ForwardRef as ReactComponent };